export const DISC_MEDIA_TYPE = {
    BLURAY_MEDIA_TYPE: 'BD',
    DVD_MEDIA_TYPE: 'DVD'
}


// WEBPACK FOOTER //
// ./src/disc/actions/disc-constants.js